import React from "react"
import { Link } from "gatsby"
import Button from '@material-ui/core/Button'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import s from './header.module.css'

const ColorButton = withStyles(() => ({
  root: {
    color: '#fff',
    fontFamily: 'DINNEXTLTPRO-MEDIUMCOND',
    height: '30px',
    fontWeight: '800',
    padding: '8px',
    fontSize: '16px',
    backgroundColor: '#000',
    '&:hover': {
      backgroundColor: '#000',
    }
  },
}))(Button)

const useStyles = makeStyles(() => ({
  margin: {
    marginLeft: '20px',
    borderRadius: '0px',
  }
}))

export function Header() {
  const classes = useStyles()

  return (
    <header className={s.header}>
      <div className={s.nav}>
        <Link
          to="/dumbo"
        >
          <img alt='cinch-market' className={s.cinch} src='https://cdn.shopify.com/s/files/1/0354/2607/4668/files/Artboard_1_2x-1_240x@2x.png?v=1589400055'></img>
        </Link>
        <div className={s.seperator}>|</div>
        <div className={s.mobile}>
            <div className={s.partner}>
              <b>DUMBO</b>&nbsp;DELIVERY
            </div>
        </div>               
        <div className={s.partner}>
          <span className={s.partnerText}>IN PARTNERSHIP WITH</span> <img alt='dumbo' style={{ marginLeft: `20px`, maxHeight: `47px`, margin: 0 }} src="/dumbo.png"></img>
        </div>
      </div>
    </header>
  )
}